import { FailureType } from "./types";
import { FC } from "react";
export const PaymentFailure: FC<FailureType> = ({ status, errorDetails }) => {
  const getErrorStatus = () => {
    let error = 'failed'
    if(errorDetails === null) return `Your payment request has been ${error}`;
    const { errorCode } = errorDetails[0];
    if(errorCode === 'EPG_6824') error = 'cancelled.';
    else if(errorCode === 'EPG_51') error = 'failed.';
    return `Your payment request has been ${error}`
  }

  return (
    <div className="flex flex-col items-center justify-center m-auto">
      <div id="logo" className="flex items-center justify-center h-1/6 mt-5 ">
        <img src="/logo.svg" alt="NHL Logo" />
      </div>
      <div className="flex items-center justify-center fixed top-0 h-full">
        <p className="text-red-700 h-10 px-1">{getErrorStatus()}</p>
      </div>
    </div>
  );
};
